import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { purchaseOrder } from '../../actions/dashboardAction'
import { Row, Col, Card, CardHeader, CardBody, Table, Badge } from 'reactstrap'
import { FORM_CONSIGNEE, FORM_SUPPLIER, FORM_SHIPPER, FORM_RESELLER, FORM_VESSEL_OP, FORM_REGULATOR } from '../../actions/constant'

let userId = localStorage.getItem('tolaut@userId') || null
let form = localStorage.getItem('tolaut@form') || null

class LatestPurchaseOrder extends Component {
  componentDidMount() {
    let data = {}

    if (form === FORM_CONSIGNEE) {
      data.consignee_id = userId
    }
    
    if (form === FORM_SUPPLIER) {
      data.supplier_id = userId
    }
    
    if (form === FORM_SHIPPER) {
      data.shipper_id = userId
      data.is_approve = 1
    }

    this.props.purchaseOrder(data)
  }

  render() {
    if (this.props.purchaseOrderIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.purchaseOrderHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        <Row>
          <Col xs="12" sm="12" md="12" lg="12">
            <Card>
              <CardHeader className="text-center">
                <h5>PO Terbaru</h5>
              </CardHeader>
              <CardBody className="p-0">
                {this.props.purchaseOrderIsSuccess &&
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th className="text-center">No. PO</th>
                        <th className="text-center">Tanggal</th>
                        {(form === FORM_SUPPLIER || form === FORM_SHIPPER) &&
                          <th>Consignee</th>
                        }
                        {(form === FORM_CONSIGNEE || form === FORM_SHIPPER) &&
                          <th>Supplier</th>
                        }
                        {form !== FORM_SHIPPER &&
                          <th>JPT</th>
                        }
                        <th className="text-center">Trayek</th>
                        <th className="text-center">Origin</th>
                        <th className="text-center">Destination</th>
                        <th className="text-center">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.props.purchaseOrderData.data.map((item) => (
                        <tr key={item.id}>
                          <td className="text-center">
                            <Link to={"purchase/view/" + item.id}>{item.no_po}</Link>
                          </td>
                          <td className="text-center">
                            {moment(item.date_po).format('DD MMMM YYYY')}
                          </td>
                          {(form === FORM_SUPPLIER || form === FORM_SHIPPER) &&
                            <td>{item.consignee_name}</td>
                          }
                          {(form === FORM_CONSIGNEE || form === FORM_SHIPPER) &&
                            <td>{item.supplier_name}</td>
                          }
                          {form !== FORM_SHIPPER &&
                            <td>{item.shipper_name}</td>
                          }
                          <td className="text-center">{item.kode_trayek}</td>
                          <td className="text-center">{item.origin}</td>
                          <td className="text-center">{item.destination}</td>
                          <td className="text-center">
                            {form === FORM_CONSIGNEE ? (
                              item.is_approve === 0 ? (
                                <Badge color="secondary">Menunggu Konfirmasi Supplier</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 0) ? (
                                <Badge color="secondary">Menunggu Konfirmasi Shipper</Badge>
                              ) : (item.is_approve === 2) ? (
                                <Badge color="danger">Ditolak Oleh Supplier</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 2) ? (
                                <Badge color="danger">Ditolak Oleh Shipper</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 1) ? (
                                <Badge color="success">Diterima Oleh Shipper</Badge>
                              ) : (<div></div>)
                            ) : (form === FORM_SUPPLIER) ? (
                              item.is_approve === 0 ? (
                                <Badge color="secondary">Menunggu Konfirmasi Anda</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 0) ? (
                                <Badge color="secondary">Menunggu Konfirmasi Shipper</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 1) ? (
                                <Badge color="success">Diterima Oleh Shipper</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 2) ? (
                                <Badge color="danger">Ditolak Oleh Shipper</Badge>
                              ) : (item.is_approve === 2) ? (
                                <Badge color="danger">Ditolak</Badge>
                              ) : (<div></div>)
                            ) : (form === FORM_SHIPPER) ? (
                              item.is_approve_by_shipper == 0 && item.is_approve == 1 ? (
                                <Badge color="secondary">Menunggu Konfirmai Anda</Badge>
                              ) : (item.is_approve_by_shipper == 1 && item.is_approve == 1) ? (
                                <Badge color="success">Diterima</Badge>
                              ) : (item.is_approve_by_shipper == 2) ? (
                                <Badge color="danger">Ditolak</Badge>
                              ) : (<div></div>)
                            ) : (form === FORM_REGULATOR || form === FORM_VESSEL_OP || form === FORM_RESELLER) ? (
                              item.is_approve === 0 ? (
                                <Badge color="secondary">Menunggu Konfirmasi Supplier</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 0) ? (
                                <Badge color="secondary">Menunggu Konfirmasi Shipper</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 1) ? (
                                <Badge color="success">Diterima Oleh Shipper</Badge>
                              ) : (item.is_approve === 1 && item.is_approve_by_shipper === 2) ? (
                                <Badge color="danger">Ditolak Oleh Shipper</Badge>
                              ) : (item.is_approve === 2) ? (
                                <Badge color="danger">Ditolak Oleh Supplier</Badge>
                              ) : (<div></div>)
                            ) : (<div></div>)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

LatestPurchaseOrder.propTypes = {
  purchaseOrderIsSuccess: PropTypes.bool.isRequired,
  purchaseOrderHasError: PropTypes.bool.isRequired,
  purchaseOrderIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    purchaseOrderData: state.dashboard.purchaseOrderData,
    purchaseOrderIsSuccess: state.dashboard.purchaseOrderSuccess,
    purchaseOrderHasError: state.dashboard.purchaseOrderError,
    purchaseOrderIsLoading: state.dashboard.purchaseOrderLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    purchaseOrder: (data) => dispatch(purchaseOrder(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LatestPurchaseOrder)